import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { BackendGateway } from '@shared/types/frontend/backend-gateway';

import displayName from '@shared/utils-frontend/display-name';

type ContextProps = {
  backendGateway: BackendGateway;
};

// @ts-expect-error missing properties
const BackendContext = createContext<BackendGateway>({});

export const withBackendContext = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const component = (props: Omit<P, 'backendGateway'>) => (
    <BackendContext.Consumer>
      {(backendGateway: BackendGateway) => (
        // @ts-expect-error we expect that backendGateway can be overwritten in the unit tests
        <Component backendGateway={backendGateway} {...(props as P)} />
      )}
    </BackendContext.Consumer>
  );

  component.displayName = displayName(Component);

  return component;
};

export default BackendContext;
